import { Link } from '@tanstack/react-router';
import type { DemoPersona } from '@/lib/auth';
import { useT } from '@/lib/i18n';

/**
 * Above the top bar while a demo persona is signed in (ADR-0020): the companies are samples shared
 * with other visitors, changes are kept until the next reset, and the other persona is one click
 * away.
 */
export function DemoBanner({ persona }: { persona: DemoPersona }) {
  const other: DemoPersona = persona === 'owner' ? 'accountant' : 'owner';
  const t = useT();
  return (
    <div
      role="status"
      data-testid="demo-banner"
      className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 border-b bg-brand-violet-50 px-4 py-2 text-center text-sm text-brand-ink"
    >
      <span>
        <strong className="font-semibold">
          {persona === 'owner' ? t('demo.asOwner') : t('demo.asAccountant')}
        </strong>{' '}
        {t('demo.rest')}
      </span>
      <Link
        to="/demo"
        search={{ as: other }}
        reloadDocument
        className="font-semibold text-primary hover:underline"
      >
        {other === 'owner' ? t('demo.switchToOwner') : t('demo.switchToAccountant')}
      </Link>
      <Link to="/signup" className="font-semibold text-primary hover:underline">
        {t('demo.createAccount')}
      </Link>
    </div>
  );
}
